export const getLocationNameBySuffix = (suffix, locations) => {
  const { name = '' } = locations.find(l => l.suffix === suffix) || {};

  return name;
};
